import routerOptions0 from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}